import http from "@/services/http"

export function hasSensor(body) {
  return http.post(`gps-data/has-sensors`, body)
}
export function carLastLocations(body) {
  return http.post(`gps-data/last-locations`, body)
}
export function getReportLastLocations(body) {
  return http.downloadXLS(`gps-data/last-locations-report`, body, "Последние данные трекинга техники")
}
export function carTracks(body) {
  return http.post(`gps-data/tracks`, body)
}
export function carLastLocationsTiming(body) {
  return http.postProgress(`gps-data/last-locations`, body)
}
export function sensormessages(body) {
  return http.post(`gps-data/sensor-messages`, body)
}
export function getGpsDataReport(body) {
  return http.downloadXLS("gps-data/tracks-report", body, "Таб GPS")
}


export function getReport(body, filename) {
  return http.downloadXLS("car-sensors/excel", body, filename)
}
export function post(body) {
  return http.post(`car-sensors`, body)
}
export function put(body) {
  return http.put(`car-sensors`, body)
}
export function remove(id) {
  return http.delete(`car-sensors?carSensorId=${id}`)
}

export function postMany(body) {
  return http.post("carsensors/configure", body)
}
export function getGpsSensorParameters(carId) {
  return http.getCache(`GpsSensorParameters?carIdsString=${carId}`)
}
